import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { ISignForm } from "../../interfaces/ISignForm";
import {
  setSignColor,
  signColorOptions,
} from "../../helper/signGeneratorHelper";
type SignColorFormProps = {
  signForm: UseFormReturn<ISignForm, any, ISignForm>;
};
const useStyles = makeStyles({
  colorSelectionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: tokens.spacingVerticalS,
    marginTop: tokens.spacingVerticalXXL,
  },
  cube: {
    position: "relative",
    width: "48px",
    height: "48px",
    border: "2px solid var(--borderColor)",
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
    overflow: "hidden",
    transition: "transform 0.3s ease, border-color 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  diagonalBorder: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "var(--color1)",
      clipPath: "polygon(0 0, 100% 0, 0 100%)",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "var(--color2)",
      clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
    },
  },
  cursorPointer: {
    cursor: "pointer",
  },
});
export const SignColorForm = ({ signForm }: SignColorFormProps) => {
  const styles = useStyles();
  const signColors = signColorOptions();
  const { watch, setValue } = signForm;
  const [selectedSign, setSelectedSign] = useState<any>(
    signColors.find(
      (x) =>
        x.primaryColor === watch("primaryColor") &&
        x.secondaryColor === watch("secondaryColor")
    ) || signColors[0]
  );

  return (
    <>
      <div className={styles.colorSelectionGrid}>
        {signColors.map((cube, index) => (
          <div
            key={index}
            onClick={() => {
              setSelectedSign(cube);
              setSignColor(cube, setValue);
            }}
            className={mergeClasses(
              styles.cube,
              index !== selectedSign && styles.cursorPointer
            )}
            style={
              {
                "--color1": cube.primaryColorCode,
                "--color2": cube.secondaryColorCode,
                "--borderColor":
                  selectedSign.key === cube.key ? "#000000" : "#B3B3B3",
              } as React.CSSProperties
            }
          >
            <div className={styles.diagonalBorder}></div>
          </div>
        ))}
      </div>
    </>
  );
};
